module.exports = __webpack_public_path__ + "static/media/logoB.a2950261.svg";